import { render, staticRenderFns } from "./ModuleDisabled.vue?vue&type=template&id=d0363ff2"
import script from "./ModuleDisabled.vue?vue&type=script&lang=js"
export * from "./ModuleDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports